<section class="accueil-page" aria-label="Accueil BiodivScan Intranet">
  <h1>BiodivScan Intranet</h1>
</section>